import React from 'react';
import '../styles/PrivacyPolicy.css';
 
 
const Support = () => {
  // Get the URL from the environment variable
  const formUrl = process.env.REACT_APP_MICROSOFT_FORM_URL;

  return (
    <div className="background">
      <h1>Support</h1>
          
      {/* Embed Microsoft Form here */}
      <div className="microsoft-form">
        <iframe
          width="1250"
          height="950"
          src={formUrl}   
          frameBorder="0"
          marginWidth="0"
          marginHeight="0"
          allowFullScreen
          webkitallowfullscreen
          mozallowfullscreen
          msallowfullscreen
        ></iframe>
      </div>
    </div>
  );
}

export default Support;
